.fp-dynamic-grid(v-if='club' ref='grid')
  TransitionGroup(name='live-auction-card-group')
    LiveAuctionCardVue(v-for='(card, index) in cards' :key='card.exclusive?.id || card.component.name' :card-px-size='cardPxSize' data-test='cards')
      component(:is='card.component' :club='club' :exclusive='card.exclusive' :shaking='card.shaking' :exclusives='exclusives')
